// The fields a sponsor plate is made of, whichever band it sits on: a logo stored as a path under
// `/assets`, and a website that becomes the href of a link on a public page.

/**
 * CP's own address for a stored asset path. The stored value is a path under /assets (never an
 * absolute address: the same document serves DEV and production, where the API origin differs),
 * so the two are joined here rather than at every <img>.
 */
export const assetSrc = path => {
  const stored = String(path || "").trim().replace(/^\/+/, "")
  return stored ? `${process.env.REACT_APP_API_URL}/assets/${stored}` : ""
}

/** The bare filename back out of a stored path, for anything that needs it on its own. */
export const logoFilename = logoUrl => String(logoUrl || "").split("/").pop()

// The API accepts only http(s) for the website, because it becomes the href of a link on a public
// page — a `javascript:` URL there would be an XSS vector. Admins type bare hostnames, so add the
// scheme rather than bouncing the form. Anything with a scheme already is left for the API to judge.
export const normalizeWebsite = website => {
  const trimmed = String(website ?? "").trim()
  if (!trimmed) return ""
  return /^[a-z][a-z0-9+.-]*:/i.test(trimmed) ? trimmed : `https://${trimmed}`
}
